import { Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import FormikTextbox from "src/components/Common/UI/Formik/FormikTextbox";
import FormikDropdown from "src/components/Common/UI/Formik/FormkDropdown";
import { useGetAllProvidersList } from "src/pages/Configuration/Parameters/Others/Providers/api/getAllProvidersList";
import * as Yup from "yup";


const BillingUploadForm = ({ initialValues, onSubmit }: BillingUploadFormProps) => {
  const { t } = useTranslation();
  const getAllProvidersListQuery = useGetAllProvidersList();
  
  const currentYear = new Date().getFullYear();

  const validationSchema= Yup.object({
    year: Yup.string()
      .required('Το πεδίο είναι υποχρεωτικό')
      .matches(/^\d{4}$/, 'Το έτος πρέπει να είναι τετραψήφιος αριθμός')
      .test('is-valid-year', 'Το έτος πρέπει να είναι μεταξύ 1900 και του τρέχοντος έτους', (value) => {
        const year = parseInt(value, 10);
        return year >= 1900 && year <= currentYear;
      }),
    month: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
    providerID: Yup.string().required('Το πεδίο είναι υποχρεωτικό')
  })

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values, formikHelpers) => {
        onSubmit(values, formikHelpers);
      }}
      validationSchema={validationSchema}
    >
      {({ isSubmitting }) => (
        <Form>
          <Container fluid className="p-0">
            <Row> 
              <Col xs={6}>
                <FormikTextbox 
                  label={"Έτος"} 
                  fieldName={"year"}
                />
              </Col>

              <Col xs={6}>
                <FormikDropdown
                  label={"Μήνας"}
                  fieldName={"month"}
                >
                   <option value="">{t("Επιλέξτε Μήνα")}</option>
                   <option value="1">{t("Ιανουάριος")}</option>
                   <option value="2">{t("Φεβρουάριος")}</option>
                   <option value="3">{t("Μάρτιος")}</option>
                   <option value="4">{t("Απρίλιος")}</option>
                   <option value="5">{t("Μάιος")}</option>
                   <option value="6">{t("Ιούνιος")}</option>
                   <option value="7">{t("Ιούλιος")}</option>
                   <option value="8">{t("Αύγουστος")}</option>
                   <option value="9">{t("Σεπτέμβριος")}</option>
                   <option value="10">{t("Οκτώβριος")}</option>
                   <option value="11">{t("Νοέμβριος")}</option>
                   <option value="12">{t("Δεκέμβριος")}</option>
                </FormikDropdown>
              </Col>

              <Col xs={6}>
                <FormikDropdown 
                  label={t("Πάροχος")} 
                  fieldName={"providerID"}
                >
                  <option value="">{t("Επιλέξτε Πάροχο")}</option>
                  {getAllProvidersListQuery.data &&
                    getAllProvidersListQuery.data.map((provider) => (
                      <option key={provider.id} value={provider.id}>
                        {provider.description}
                      </option>
                    ))
                  }
                </FormikDropdown>
              </Col>
              
            </Row>

            <Row className="row">
              <Col xs="12" className="my-4 text-center">
                <Button
                  type="submit"
                  size="sm"
                  color="primary"
                  disabled={isSubmitting}
                >
                  {t("Επιλογή")}
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
      )}
    </Formik>
  )
}

export default BillingUploadForm;

type BillingUploadFormProps = {
  initialValues: IBillingUploadForm;
  onSubmit: (
    values: IBillingUploadForm,
    formikHelpers: FormikHelpers<IBillingUploadForm>
  ) => void;
  //onClearForm: () => void;
}